const CONSTANTS = {
  LOGIN_REQ: "LOGIN_REQ",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGIN_FAIL: "LOGIN_FAIL",
  LOGOUT_USER: "LOGOUT_USER",
  SET_SESSION: "SET_SESSION",
  SET_USER: "SET_USER",
  SET_LOADING: "SET_LOADING",
  REFRESH_SESSION: "REFRESH_SESSION",
  CHECK_SESSION: "CHECK_SESSION",
  RESET_ALL: "RESET_ALL",
  USER_MUST_CHANGE_PASSWORD: "USER_MUST_CHANGE_PASSWORD",
  CHANGE_USER_PASSWORD: "CHANGE_USER_PASSWORD",

  LS_SIDEBAR_OPEN: "sidebarOpen",
  LS_LOGGED_IN: "loggedIn",
  LS_USER_MUST_CHANGE_PASSWORD: "userMustChangePassword",

  GET_APPROVAL_EXPIRATION_STATUS: "GET_APPROVAL_EXPIRATION_STATUS",
  SET_APPROVAL_EXPIRATION_STATUS: "SET_APPROVAL_EXPIRATION_STATUS"
};

export default CONSTANTS;
